var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Chip, Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { baseColors } from '../../../Themes/colors';
var TYPE_ICON_MAP = {
    commercial: 'icon-Building',
    consumer: 'icon-profile',
};
var getTypeIcon = function (label) {
    var key = Object.keys(TYPE_ICON_MAP).find(function (k) {
        return label.toLowerCase().includes(k);
    });
    return key ? TYPE_ICON_MAP[key] : 'icon-profile';
};
var STATUS_VARIANT_MAP = {
    approved: { text: baseColors.successPreset[50], bg: baseColors.successPreset[60] },
    docs: { text: baseColors.bluePreset[50], bg: baseColors.bluePreset[60] },
    warning: { text: baseColors.warningPreset[20], bg: baseColors.warningPreset[30] },
    danger: { text: baseColors.errorPreset[20], bg: baseColors.errorPreset[30] },
    default: { text: baseColors.bluePreset[40], bg: baseColors.greyPreset[55] },
};
var getStatusVariant = function (status) {
    var n = status.toLowerCase();
    if (n.includes('approved'))
        return 'approved';
    if (n.includes('docs') || n.includes('document'))
        return 'docs';
    if (n.includes('withdrawn') || n.includes('submitted') || n.includes('credit'))
        return 'warning';
    if (n.includes('declined') || n.includes('cancel'))
        return 'danger';
    return 'default';
};
var baseChipStyles = {
    height: 20,
    borderRadius: 4,
    fontSize: 10,
    fontWeight: 500,
    padding: '4px 6px',
    '& .MuiChip-label': {
        padding: 0,
    },
    '& .MuiChip-icon': {
        fontSize: 12,
        margin: 0,
        color: 'currentColor',
        marginRight: 4,
    },
};
var TypeChip = styled(Chip)(function () { return (__assign(__assign({}, baseChipStyles), { color: baseColors.bluePreset[40], backgroundColor: baseColors.greyPreset[55], border: "1px solid ".concat(baseColors.greyPreset[40]) })); });
var StatusChip = styled(Chip, {
    shouldForwardProp: function (prop) { return prop !== 'textcolor' && prop !== 'bgcolor'; },
})(function (_a) {
    var textcolor = _a.textcolor, bgcolor = _a.bgcolor;
    return (__assign(__assign({}, baseChipStyles), { color: textcolor, backgroundColor: bgcolor }));
});
export var BacklogHoverTooltip = styled(function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement(Tooltip, __assign({}, props, { arrow: true, classes: { popper: className }, placement: "top" })));
})(function () {
    var _a;
    return (_a = {},
        _a["& .".concat(tooltipClasses.tooltip)] = {
            backgroundColor: baseColors.bluePreset[10],
            color: baseColors.fullWhite,
            borderRadius: 8,
            boxShadow: '0 10px 24px rgba(0,0,0,0.24)',
            padding: '14px 18px',
            minWidth: 250,
            maxWidth: 350
        },
        _a["& .".concat(tooltipClasses.arrow)] = {
            color: baseColors.bluePreset[10],
        },
        _a);
});
export var BacklogTypeBadge = function (_a) {
    var value = _a.value;
    var text = (value === null || value === void 0 ? void 0 : value.trim()) ? value : '--';
    return (React.createElement(TypeChip, { label: text, size: "small", icon: React.createElement("span", { className: getTypeIcon(text) }) }));
};
export var BacklogStatusBadge = function (_a) {
    var value = _a.value;
    var text = (value === null || value === void 0 ? void 0 : value.trim()) ? value : '--';
    var _b = STATUS_VARIANT_MAP[getStatusVariant(text)], textcolor = _b.text, bgcolor = _b.bg;
    return (React.createElement(StatusChip, { label: text, size: "small", textcolor: textcolor, bgcolor: bgcolor }));
};
